import clsx from 'clsx'

import { Flex } from 'components/common/flex/Flex'
import { ReactComponent as TextDecoration } from 'components/strategySection/assets/text-decoration.svg'
import trafficLightImgSrc from 'components/strategySection/assets/traffic-light.gif'
import { Scheme } from 'components/strategySection/scheme/Scheme'
import styles from 'components/strategySection/StrategySection.module.scss'

export const StrategySection = () => {
  return (
    <div className={styles.container}>
      <Flex justify="between" className={styles.content}>
        <div className={styles.textContainer}>
          <img src={trafficLightImgSrc} alt="Traffic light" className={styles.trafficLight} />
          <div className={styles.descriptionContainer}>
            <p className={styles.description}>
              Projects best aligned to business strategy and key metrics get the
            </p>
            <p className={clsx(styles.description,'font-bold italic')}>
              green light!
            </p>
            <TextDecoration className={styles.textDecoration} />
          </div>
          <div className={styles.description1Container}>
            <p className={styles.description}>
              Once prioritized, the daily details of a project will appear in
              <span className='font-bold'>
                &nbsp;Adobe Workfront,
              </span>
              <div className={styles.description}>
                giving everyone full transparency and visibility.
              </div>
            </p>
          </div>
        </div>
        <Scheme />
      </Flex>
    </div>
  )
}
